interface EmberLogoProps {
  className?: string
}

export function EmberLogo({ className = 'h-8' }: EmberLogoProps) {
  return (
    <img
      src="/ember-logo.png"
      alt="Ember"
      className={className}
      style={{ objectFit: 'contain' }}
      draggable={false}
    />
  )
}
